import Socket from '../connection/socket';
import { Message } from '../stores/types/connection';
import * as SettingsActions from '../stores/actions/settings';
import { getState, socketListenerDispatch } from './socket-listener-main';

function handleUpdateState(message: any) {
	socketListenerDispatch(SettingsActions.replaceState(message.message));
}

interface FeatureFlagUpdateMessage extends Message {
	message: [string, boolean];
}

const handleFeatureFlagUpdate = async ({ message }: FeatureFlagUpdateMessage) => {
	if (
		message
		&& Array.isArray(message)
		&& typeof message[0] === 'string'
		&& typeof message[1] === 'boolean'
	) {
		socketListenerDispatch(SettingsActions.updateFeatureFlag(message));
	}
};

const handleFeatureFlagsRefresh = () => {
	const { SessionReducer: { meeting } } = getState();
	if (meeting?.meeting) {
		socketListenerDispatch(SettingsActions.getFeatureFlagOverrides(meeting.meeting));
	}
};

export default function Settings(socket: Socket) {
	socket.addListener('settings-update', handleUpdateState);
	socket.addListener('feature-flag-update', handleFeatureFlagUpdate);
	socket.addListener('feature-flags-refresh', handleFeatureFlagsRefresh);
}
